import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Status404NotFound from './Status404NotFound';

export default function RouteMenu({ match, indexComponent, indexRender, children }) {
    return <Switch>
        <Route exact path={match.url} render={indexRender} component={indexComponent} />
        {children}
        <Route path='/' component={Status404NotFound} />
    </Switch>;
}